module.exports = __webpack_public_path__ + "246ef20c4866aca439c3acafa43d93ed.jpg";